const useDispatch = storm => storm.dispatch;

export default useDispatch;
